module.exports = __webpack_public_path__ + "img/monkey_gland.494b990a.jpg";